import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorModalService } from '../services/error-modal.service';
import { SKIP_ERROR_MODAL } from '../http/skip-error-modal.token';
import { getBackendErrorMessage } from '../http/get-backend-error-message';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const errorService = inject(ErrorModalService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const skip = req.context.get(SKIP_ERROR_MODAL);
      const shouldShow =
        !skip &&
        err.status !== 401 &&
        (err.status === 0 || err.status >= 400);

      if (shouldShow) {
        errorService.show(getBackendErrorMessage(err));
      }

      return throwError(() => err);
    }),
  );
};
